<mat-card appearance="outlined" matRipple (click)="selectOrganizationUnit()">
  @if ((session$ | async); as session) {
    <mat-card-header>
      <mat-card-title>{{ name$ | async }}</mat-card-title>
      <mat-card-subtitle>{{ parent$ | async }}</mat-card-subtitle>
    </mat-card-header>
  }
</mat-card>
